<template>
  <div style="background:#F4F4F4">
    <div class="top">
      <div class="inNum" @click="jumpOldMap" style="cursor: pointer;">
        <h2>
          <countTo :startVal='0' :endVal='oldTypeCount' separator="" :duration='2000'></countTo>
        </h2>
        <p>长者数据</p>
      </div>
      <div class="allNum inNum" @click="jumpService" style="cursor: pointer;">
        <h2>
          <countTo :startVal='0' :endVal='empNum' :duration='2000'></countTo>
        </h2>
        <p>服务人员</p>
      </div>
      <div class="birthNum inNum" @click="jumScene" style="cursor: pointer;">
        <h2>
          <countTo :startVal='0' :endVal='sceneNum' separator="" :duration='2000'></countTo>
        </h2>
        <p>场景应用</p>
      </div>
      <div class="shebeiNum inNum" @click="jumDevice" style="cursor: pointer;">
        <h2>
          <countTo :startVal='0' :endVal='equipmentCount' separator="" :duration='2000'></countTo>
        </h2>
        <p>设备总数</p>
      </div>
      <div class="orderNum inNum" @click="jumOrder" style="cursor: pointer;">
        <h2>
          <countTo :startVal='0' :endVal='orderNum' :duration='2000'></countTo>
        </h2>
        <p>活动课程</p>
      </div>
    </div>
    <el-row>
      <div style="display:flex;justify-content: space-around;margin-bottom:10px">
        <div style="width:48%">
          <div style="display:flex;justify-content: space-between;margin-bottom: 8px;">
            <h2>长者年龄分析</h2>
          </div>
          <div id="chartLine" ref="chartLine" style="width:100%; height:270px;background:#ffffff; border-radius: 8px;">
          </div>
        </div>

        <div style="width:48%">
          <div style="display:flex;justify-content: space-between;margin-bottom: 8px;">
            <h2 style>今日工单</h2>
          </div>
          <div id="chartBar" ref="chartBar" style="width:100%; height:270px;background:#ffffff; border-radius: 8px;">
          </div>
        </div>
      </div>

      <div style="display:flex;justify-content: space-between;margin:20px 20px">
        <div class="order">
          <div class="title" style="padding:8px">
            <h2 style="margin-top:-10px">工单分析</h2>
            <div>
              <span ref="num" style="cursor: pointer;color:#E7505A;margin-right:4px" @click="changOrderNum">数量</span>
              <span ref="type" style="cursor: pointer;" @click="changOrderType">类型</span>
            </div>
          </div>
          <div v-show="isNum" ref="orderAnalysis" style="width:100%;height:220px"></div>
          <div v-show="!isNum" ref="orderType" style="width:400px;height:220px"></div>
        </div>
        <div class="shebei">
          <h2>设备管理</h2>
          <div id="chartPie" ref="chartPie" style="width:100%; height:270px"></div>
        </div>
        <div class="olmanBirthday">
          <div style="display:flex">
            <h2 style="flex:1">生日提醒</h2>
            <p style="padding-top: 6px;cursor: pointer;" @click="jumBirthday">更多➤</p>
          </div>
          <el-table :data="birthDatas" border style="width: 100%;margin-top:10px" :header-cell-style="headerStyle">
            <el-table-column prop="oldmanName" label="姓名" align="center"></el-table-column>
            <el-table-column prop="oldAge" label="年龄" align="center"></el-table-column>
            <el-table-column prop="oldmanMonthAndDay" label="生日" align="center"></el-table-column>
          </el-table>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import echarts from "echarts";
import countTo from 'vue-count-to';
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
import util from "@/utils/util.js";
export default {
  name: "jChart",
  components: {
    countTo
  },
  data() {
    return {
      isNum: true,
      collapsed: "", //从localStorage里面获取collapsed的状态，面包屑的 false 和 true
      isA: true, //class动态类名的状态A
      isB: false, //class动态类名的状态B
      contentStyleObj: { width: "" }, //style动态样式
      myChartBar: "",
      equipmentCount: 0, //设备总数
      birthNum: 0, //当天生日数
      ruyuan: 0, //入院老人
      jujia: 0, //居家老人
      orderNum: 0,
      sceneNum:0,
      empNum:1,
      serverManCount: 0,//服务人员数量
      todayBirthdayNum: 2,//当日生日人数
      oldTypeCount: 0, //老人总数
      totalAlart: 0, //报警总数
      handleNo: 0, //处理未完成的报警数
      handleYes: 0, //处理已完成报警数
      handleAnother: 0, //其他报警
      ruyuanList: [], //入院老人人数集合
      jujiaList: [], //居家老人人数集合
      oldTypeCountList: [], //老人总数集合
      oldmanBirthDate: util.formatDate.GetDateStr(3), //获取七天后老人生日的日期yyyy-MM-dd
      oldmanMonthAndDay: "", //获取回显的老人生日 MM-dd
      yearPick: util.formatDate.format(new Date(), "yyyy"), //入院老人增长选择年份
      yearPickBar: util.formatDate.format(new Date(), "yyyy-MM"), //老人分析选择年份
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      pickerOptionsBar: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      chartBar: null,
      chartLine: null,
      chartPie: null,
      chartBarTitleData: [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月"
      ],
      chartBarInOlderData: [],
      chartBarOutOlderData: [],
      lineChoose: "week",
      birthDatas: [

      ],
      deviceSumList: [], //获取的处理过的设备数据
      follow: "",
      watchxiaoxin: "",
      chuangidanZn: "",
      alarm: "",
      gateway: "",
      button: "",
      bodyinduction: "",
      accessDkq: "",
      isShowOld:false,
      accessKa: "",
      chuangdianCsun: "",
      watchHugong: "",
      ageDate: [],
      setTotalNum: "" //设备总数
    };
  },
  methods: {
    changOrderNum() {
      this.isNum = true
      this.$refs.num.style.color = "#E7505A"
      this.$refs.type.style.color = "#000000"
    },
    changOrderType() {
      this.isNum = false
      this.$refs.type.style.color = "#E7505A"
      this.$refs.num.style.color = "#000000"
    },
    jumScene(){
      bus.$emit("homePage", {
        type: "jump",
        path: "/sceneList",
        title: "场景详情",
      });
    },
    jumpService(){
      bus.$emit("homePage", {
        type: "jump",
        path: "/ServicePersonnel",
        title: "服务人员列表",
      });
    },
    jumBirthday() {
      bus.$emit("homePage", {
        type: "jump",
        path: "/OldmanBirthday",
        title: "老人生日",
      });
    },
    jumOrder() {
      bus.$emit("homePage", {
        type: "jump",
        path: "/CourseManage",
        title: "课程活动",
      });
    },
    jumDevice(){
      bus.$emit("homePage", {
        type: "jump",
        path: "/DeviceManager",
        title: "设备运营管理",
      });
    },
    getEmpt() {
      this.$postJson("uac/staff/selectStaffByNotSpecoalist",{}).then(res=>{
        this.empNum = Number(res.result.total);
        
        this.$postJson("uac/dept/getDeptVoAll").then(res=>{
          let params = {
            pageNum: 1,
            pageSize: 1,
            deptId: res.result[0].id
          };
          this.$postJson("uac/emp/queryUserListByEmpWithPage", params).then(res2=>{
            this.empNum = this.empNum+ Number(res2.result.total);
          });
        });
      })
      

    },
    getOrderTotal() {
      let params = new Object();
      params.pageNum = 1;
      params.pageSize = 1;
      params.groupId = sessionStorage.getItem("groupId");
      this.$postJson("omc/onlineCourse/select",params).then(res => {
        this.orderNum = Number(res.result.total);
      });

      this.$postJson("dmc/device/showScene").then(res => {
        let scene = 0;
        res.result.forEach(item=>{
          scene = scene + item.count;
        })
        this.sceneNum = scene;
      });


    },

    //获取院外老人和院内老人以及总数
    getElderTotal(street,community){
      //omc/elder/listWithPage
      this.$postJson("omc/elder/listWithPage",{
        street: street,
        community: community,
        pageSize:1
      }).then(res=>{
        this.oldTypeCount = Number(res.result.total);
      })
    },
    getOldmanTotal() {
      this.$postJson("omc/Oldman/quickShowAllOldMan").then(res => {
        this.oldTypeCount = Number(res.result.total);
        if(this.oldTypeCount == 0){
          this.$postJson("uac/group/getDb/"+sessionStorage.getItem("groupId")).then(res => {
            let street = res.result.street;
            let community = res.result.community;
            window.sessionStorage.setItem("street",street);
            window.sessionStorage.setItem("community",community);
            if(street!=null || community !=null){
              this.getElderTotal(street,community);
              this.empNum = res.result.employeesNum;
            }
          });
        }else{
          this.isShowOld = true;
        }
      });
      this.$postJson("omc/statistics/oldAgeStatistics").then(res => {
        this.ageDate = [res.result.lessSixty, res.result.sixty, res.result.seventy, res.result.eighty, res.result.ninety, res.result.hundred];
        this.drawLineChart();
      });
    },
    //获取老人生日提醒信息
    oldBirthdayRemind() {
      //统计今日老人生日数量
      //统计今日老人生日数量
      var date = new Date();//当前时间
      var year = date.getFullYear() //返回指定日期的年份
      var month = date.getMonth() + 1
      var day = date.getDate()
      this.oldmanMonthAndDay = (month < 10 ? '0' + month : month) + "-" + (day < 10 ? '0' + day : day);
      //当前时间 
      var curTime = year + "-" + (month < 10 ? '0' + month : month) + "-" + (day < 10 ? '0' + day : day);
      this.$get("omc/analysis/oldBirthdayRemind", { date: curTime }).then(res => {
        this.todayBirthdayNum = res.length
        var newArr = [];
        res.forEach((item, index) => {
          let obj = {};
          obj.oldmanId = item.oldmanId;
          obj.oldmanMonthAndDay = item.birthday.substring(5, 10);
          //oldmanMonthAndDay
          obj.oldmanName = item.oldmanName;
          obj.oldAge = item.oldAge;
          obj.nursingLevel = item.nursingLevel;
          if (newArr.length < 4) {
            newArr.push(obj);
          }
        });
        this.birthDatas = newArr;
      })
    },
    //设备报警数据分析
    drawBarChart() {
      // 基于准备好的dom，初始化echarts实例
      if (this.$refs.chartBar) {
        this.chartBar = echarts.init(this.$refs.chartBar);
        let dataAxis = [
          "咨询服务",
          "亲情关怀",
          "生活照料",
          "助行服务",
          "助餐服务",
          "医疗服务",
          "上门巡诊",
          "康复服务"];
        let seriesList = [
          {
            name: "下单量",
            type: "bar",
            barGap: "-100%",
            barWidth: 10,
            itemStyle: {
              normal: {
                barBorderRadius: 5,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(156,107,211,0.8)" },
                  { offset: 0.2, color: "rgba(156,107,211,0.5)" },
                  { offset: 1, color: "rgba(156,107,211,0.2)" }
                ])
              }
            },
            z: 0,
            data: [
              5,
              2,
              2,
              1,
              2,
              2,
              3,
              2
            ]
          },
          {
            name: "完成量",
            type: "bar",
            barWidth: 10,
            itemStyle: {
              normal: {
                barBorderRadius: 5,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#956FD4" },
                  { offset: 1, color: "#3EACE5" }
                ])
              }
            },
            data: [
              1,
              1,
              1,
              0,
              1,
              1,
              2,
              1
            ]
          },
        ];
        var option = {
          tooltip: { //悬浮显示的
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data: ["下单量", "完成量"],
            textStyle: {
              color: "#3C3C3C"
            },
            top: "0%"
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            data: dataAxis,
            axisLine: {
              lineStyle: {
                color: "#3C3C3C"
              }
            },
            axisTick: {
              show: false
            }
          },
          yAxis: [
            {
              splitLine: { show: false },
              axisLine: {
                lineStyle: {
                  color: "#3C3C3C"
                }
              },

              axisLabel: {
                formatter: "{value} "
              }
            },
            {
              splitLine: { show: false },
              axisLine: {
                lineStyle: {
                  color: "#3C3C3C"
                }
              },
              axisLabel: {
                formatter: "{value} "
              }
            }
          ],
          series: seriesList
        };
        this.chartBar.setOption(option);
      }
    },

    //入院老人增长分析
    drawLineChart() {
      if (this.$refs.chartLine) {
        this.chartLine = echarts.init(this.$refs.chartLine);
        var option = {
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: ['60岁以下', '60-65岁', '65-70岁', '70-75岁', '75-80岁', '80岁以上']
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              data: this.ageDate,
              type: 'bar',
              itemStyle: {
                normal: {
                  //这里是颜色
                  color: function (params) {
                    //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                    var colorList = ['#00ABBD', '#FFA100', '#0769CB', '#FFd886', "#9F2E61", "#4D670C"];
                    return colorList[params.dataIndex]
                  }
                }
              }
            },
          ]
        };
        this.chartLine.setOption(option);
      }
    },
    jumpOldMap() {
      if(this.isShowOld){
          bus.$emit("homePage", {
          type: "jump",
          path: "/ResidentManager",
          title: "长者管理",
        });
      }else{
        bus.$emit("homePage", {
          type: "jump",
          path: "/ElderList",
          title: "长者管理",
        });
      }
    
    },
    //工单分析
    order() {
      var myChartPie = this.$refs.orderAnalysis;
      if (myChartPie) {
        let chartPie = echarts.init(myChartPie);
        chartPie.setOption({
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          color: ["#FFCC66", "#2357FF", "#55DA8D", "#FF6666"],
          series: [
            {
              name: "工单数量分析",
              type: "pie",
              radius: "80%",
              center: ["50%", "50%"],
              data: [
                { value: 35, name: "已完成工单" },
                { value: 12, name: "待完成工单" },
                { value: 7, name: "超时工单" },
                { value: 8, name: "已取消工单" }
              ],
              avoidLabelOverlap: false,
              label: {
                normal: {
                  formatter: "{b}",
                  textStyle: {
                    fontSize: 12
                    // color: "#fff"
                  }
                }
              }
            }
          ]
        });
      }
    },

    //工单类型分析
    ordertypeChart() {
      var myChart = this.$refs.orderType;
      if (myChart) {
        let orderChart = echarts.init(myChart);
        orderChart.setOption({
          color: ["#1F74F1", "#00D1CE", "#55DA8D", "#3CC2F5"],
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b}: {c} ({d}%)"
          },
          series: [
            {
              name: "工单类型分析",
              type: "pie",
              radius: [50, 100],
              center: ["50%", "50%"],
              roseType: "radius",
              label: {
                normal: {
                  show: true,
                  formatter: "{b}:{c}"
                },
                emphasis: {
                  show: false
                }
              },
              data: [
                { value: 124, name: "助餐" },
                { value: 165, name: "助洁" },
                { value: 120, name: "助医" },
                { value: 136, name: "远程看护" },
              ]
            }
          ]
        });
      }
    },
    //设备数量统计分析
    drawPieChart() {
      this.equipmentCount = 0
      var myChartPie = this.$refs.chartPie;
      if (myChartPie) {
        let chartPie = echarts.init(myChartPie);
        this.$get("dmc/device/getDeviceSumList").then(res => {
          res.forEach(item => {
            this.equipmentCount += item.deviceSum
          }) //设备总数
          var newList = [];
          var num = 0;
          let title = [];
          res.forEach((item, index) => {
            num += item.deviceSum;
            if(title.length<9){
              title.push(item.deviceName);
            }
            var obj = {};
            obj.value = item.deviceSum;
            obj.name = item.deviceName;
            newList.push(obj);
          });
          this.deviceSumList = newList;
          this.setTotalNum = num;
          //将后台获取的值注入data中，echaert图形展示获取的数据
          chartPie.setOption({
            title: {
              subtext: "数量占比",
              x: "center"
            },
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c} ({d}%)"
            },
            legend: {
              orient: "vertical",
              left: "right",
              data: title
            },
            series: [
              {
                name:'设备数量分析',
                type: "pie",
                radius: ["42%", "62%"],
                center: ["35%", "50%"],
                minAngle: 20,
                avoidLabelOverlap:true,
                itemStyle: {
                  borderRadius: 10,
                  borderColor: '#fff',
                  borderWidth: 2
                },
                label: {
                  normal: {
                    show: false,
                    position: "center"
                  },
                  emphasis: {
                    show: true,
                    textStyle: {
                      fontSize: "30",
                      fontWeight: "bold"
                    }
                  }
                },
                labelLine: {
                  normal: {
                    show: false
                  }
                },
                data: this.deviceSumList,
                avoidLabelOverlap: false,
                label: {
                    normal: {
                      formatter: "{b}",
                      textStyle: {
                        fontSize: 12
                      }
                    }
                }
              }
            ]
          });
        });
      }
    },
    drawCharts() {
      this.drawBarChart();
      // this.drawLineChart();
      this.drawPieChart();
      this.order(); //工单分析
      this.ordertypeChart() //工单类型分析
    },
    //表格头颜色
    headerStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #D4D4D4;";
      }
    },
    init() {
      this.getOldmanTotal();
      this.getEmpt();
      this.getOrderTotal();
      this.drawCharts();
      this.oldBirthdayRemind();
    }
  },
  mounted: function () {
    bus.$on("changeSystemMain_websocket", () => {
      this.queryDeviceAlert();
    });
    bus.$on("collapse-content", (msg) => {
      setTimeout(()=>{
        this.chartLine.resize();
        this.chartBar.resize();
      },200)
    });

    let outjumpFlag = sessionStorage.getItem("outjump");
    if(outjumpFlag && outjumpFlag == 'true'){
      setTimeout(()=>{
        this.init();
        sessionStorage.removeItem("outjump");
      },1700)
      return;
    }
    this.init();

  },
  destroyed() {
  }
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1600px) {
  .chart-container {
    width: 1350px;
    float: left;
    margin-top: 5px;
  }

  .chart-wapper {
    width: 1500px;
    float: left;
    margin-top: 5px;
  }
}

::deep .birthDatas {
  height: 335px;
  overflow-x: hidden;
  overflow-y: scroll;
}

h2 {
  margin: 0;
  padding: 0;
}

.top {
  padding: 10px;
  display: flex;
  justify-content: space-between;

  .inNum {
    width: 190px;
    height: 134px;
    position: relative;
    color: #ffffff;
    background: url('../../assets/main/ruyuanNum.png') 0 0 no-repeat;
    background-size: 100% 100%;

    h2 {
      font-size: 78px;
      margin: 0;
      padding: 0;
      text-align: center;
      line-height: 108px;
    }

    p {
      width: 190px;
      height: 30px;
      position: absolute;
      bottom: 0;
      background: black;
      opacity: 0.3;
      text-align: center;
      line-height: 30px;
      font-size: 16px;
    }
  }

  .shebeiNum {
    background: url('../../assets/main/shebeiNum.png') 0 0 no-repeat;
    background-size: 100% 100%;
  }

  .birthNum {
    background: url('../../assets/main/shengriNum.png') 0 0 no-repeat;
    background-size: 100% 100%;
  }

  .orderNum {
    background: url('../../assets/main/gongdanNum.png') 0 0 no-repeat;
    background-size: 100% 100%;
  }

  .allNum {
    background: url('../../assets/main/allNum.png') 0 0 no-repeat;
    background-size: 100% 100%;
  }
}

.order {
  width: 30%;
  height: 270px;
  background: #ffffff;
  border-radius: 8px;

  .title {
    display: flex;
    justify-content: space-between;
  }
}

.shebei {
  width: 34%;
  height: 250px;
  background: #ffffff;
  border-radius: 8px;
  padding: 10px;
  position: relative;

  h2 {
    position: absolute;
    top: 10px;
  }
}

.olmanBirthday {
  width: 30%;
  height: 250px;
  background: #ffffff;
  border-radius: 8px;
  padding: 10px;
}</style>
